module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_c('a', {
    attrs: {
      "href": "#/c006#TOC"
    }
  }, [_vm._v("CAPITOLO 2")]), _c('a', {
    attrs: {
      "id": "Chapter02"
    }
  })]), _c('a', {
    attrs: {
      "id": "Chapter02"
    }
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])])]), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_c('a', {
    attrs: {
      "id": "Chapter02"
    }
  }, [_c('img', {
    staticClass: "section-break-symbol",
    attrs: {
      "alt": "image",
      "height": "176",
      "src": "d2d_images/image003.jpg",
      "width": "480"
    }
  })])]), _c('a', {
    attrs: {
      "id": "Chapter02"
    }
  }, [_c('h1', [_vm._v("0930 / 27 Dicembre 2021")]), _vm._v(" "), _c('p', {
    staticClass: "first-in-chapter",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-chapter-phrase"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("L")]), _vm._v("a prigione di Mara")]), _vm._v(" dondolava attraverso il cielo sotto di me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Questa era una causa di preoccupazione.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Ero in piedi sullo scafo esterno della Stazione Tombaugh, saldamente ancorata sia dai miei stivali magnetici agganciati alla griglia superficiale sia da una corda di sicurezza collegata all’Anello di Sicurezza 5 sud, segmento Tango. Tuttavia, ero rivolta al perimetro esterno del toroide, il “basso” rotazionale. Questo creava una disconnessione percettiva nel fatto che percepissi visivamente lo scafo della stazione come basso mentre il mio orecchio interno riferiva che ero sospesa sopra un abisso.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A ogni rotazione della Stazione Tombaugh, terra appariva sulla mia sinistra e attraversava la direzione che il mio orecchio interno viveva come basso. Tenendo il tempo ripassando nella mente la musica che avrei suonato al concerto della Fine dell’Anno, determinai che a terra servivano approssimativamente quarantatré secondi per completare il proprio arco e scomparire alla mia destra. Anche se ero cresciuta con le immagini, non avevo mai visto terra direttamente prima; l’addestramento per le E-tute di livello bronzo si conduceva sulla faccia interna del toroide, con il nucleo sopra di noi e vuote distese stellate su ogni lato. Trovavo il pianeta più interessante di quanto mi fossi aspettata. Dal mio punto di vista, in piedi sulla superficie sud del toroide, il polo sud magnetico di terra era in cima, ma oltre quello il pianeta era un mistero per me. Circa due terzi della parte visibile erano illuminati dal sole. Era in predominanza di un blu vivo chiazzato da intriganti sfumature di marrone e verde. Grandi quantità di vapori di acqua sospesi, nuvole, creavano aree di grigio e bianco che oscuravano la superficie. Ne dedussi che la sfumatura indicasse la densità. C’era una formazione a vortice di nubi di un bianco acceso che trovavo particolarmente attraente.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Il mio utilizzo mentale di aggettivi di valore intrinseco come "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("vivo")]), _vm._v(", "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("intrigante")]), _vm._v(" e "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("attraente ")]), _vm._v("suggeriva che stessi vivendo una risposta emotiva a terra. Particolarmente atipica era stata la mia iniziale identificazione di terra come la prigione di Mara. Non avevo mai considerato quel raccapricciante descrittore prima. Indicava che ero emotivamente distratta, forse a punto tale che il mio giudizio era fatalmente compromesso. Riflettei sulla cosa mentre restavo nel silenzio radio imposto.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quella era la prima esperienza del terzo anno dell’Addestramento Sottufficiali del Servizio Spaziale con un esercizio progettato per presentarci i conflitti di percezione, l’isolamento e il disorientamento che avremmo incontrato al di fuori delle familiari aree protette per l’attività extraveicolare sulla superficie interna del toroide. Non potevamo vederci gli uni con gli altri, essendo stati posizionati in modo da intensificare il nostro senso di isolamento nell’affrontare il vuoto da soli. Le comunicazioni erano limitate e i cronometri, le camere esterne e i localizzatori delle nostre tute erano stati disattivati. Ci era stato detto di navigare ricordandoci passi e distanze tra i segni visibili dello scafo e di misurare il tempo con i battiti del cuore. (Un metodo talmente impreciso che sospettavo che il consiglio dovesse essere umoristico. Trovavo la musica più affidabile). Dato che i cadetti non sono personale del Servizio Spaziale attivo, gli Aggiustatutto (specialisti in costruzione, manutenzione e riparazione intimamente familiari con l’esterno della stazione) fungono da ufficiali di sicurezza durante gli esercizi di addestramento EVA. L’Aggiustatutto incaricato della mia protezione era dietro di me, fuori dal mio campo visivo, per preservare la mia sensazione di solitudine.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("L’esercizio era iniziato all’Anello di Sicurezza 1, a venti metri dalla superficie interna del toroide, e sarebbe progredito fino a quando avessimo raggiunto l’Anello 10, a duecento metri dalla superficie interna. O finché non avessimo tutti fallito. Restavano ancora nove degli undici cadetti che avevano iniziato l’esercizio. Allison Winship aveva sofferto di mal di movimento all’Anello di Sicurezza 2, quaranta metri “sotto” la superficie interna del toroide. Elliot Collier aveva provato una reazione fobica irrazionale durante la transizione dall’Anello 3 all’Anello 4 ed era stato paralizzato dal panico. Entrambi i cadetti erano stati messi in sicurezza dai propri Aggiustatutto e riportati “su” alla superficie interna del toroide.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A ogni anello venivamo imbracati per un periodo non specificato di tempo e ci venivano dati enigmi mentali da risolvere e compiti fisici da eseguire per valutare il nostro livello di adattamento; a volte venivamo lasciati in silenzio a riflettere sulla nostra situazione mentre la nostra telemetria veniva monitorata. Io trascorrevo i periodi di silenzio a ripassare mentalmente le melodie che avrei eseguito al concerto della Fine dell’Anno. Mi chiedevo, ma non chiesi, cosa ne pensasse l’Aggiustatutto dietro di me dei movimenti simpatetici delle mie dita che formavano gli accordi.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Tradizionalmente, la settimana della Fine dell’Anno era un’interruzione dei doveri per il personale non essenziale... cosa che noi, in quanto studenti delle superiori, tecnicamente eravamo. Ma eravamo anche cadetti in addestramento per ruoli essenziali che avrebbero richiesto che fossimo pronti ad agire in qualunque momento. Eravamo stati convocati al Portello di Manutenzione 14 con un’allerta per crisi generale alle 0800 e avevamo dovuto fare di corsa la preparazione per l’EVA per simulare un’uscita di emergenza.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Preparatevi a sganciarvi», echeggiò la voce della comandante Tenafly nel mio casco. Il leggero ma evidente effetto eco era causato dal collegamento aperto tra me e il mio Aggiustatutto assegnato: il suo microfono trasmetteva quello che lui sentiva dagli altoparlanti.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Pronta, Cadetto Kielani?» chiese il mio Aggiustatutto. Durante il nostro regime pre-EVA troncato, avevo osservato che era un uomo muscoloso di altezza sotto la media, coi capelli neri. La targhetta col nome sul petto della sua tuta potenziata da costruzione lo identificava come “R. MEREDITH”.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Sì, Aggiustatutto Meredith», risposi. «Sappia che sto provando uno sconvolgimento emotivo potenzialmente problematico».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Annotato», rispose l’Aggiustatutto Meredith. «Ricevuto?»")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Ricevuto», disse la comandante Tenafly. «Cadetto Kielani, comprendi che questo esercizio è il primo passo nell’apprendere a riconoscere e gestire le normali risposte emotive in situazioni pericolose e disorientanti. Reazioni di stress, inclusa la paura, sono attese. Detto questo, senti che la tua capacità di completare l’esercizio sia compromessa?»")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Una mente non può valutare la sua stessa funzionalità».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Sappi che la tua telemetria fisica è nominale», disse la comandante Tenafly. «Così come lo sono state le tue prestazioni in tutti i test. Il ritmo della respirazione e del battito cardiaco indicano che il tuo livello ansiogeno è al di sotto delle norme statistiche. Tuttavia, la tua preoccupazione è prudente. Meredith, sia pronto ad assistere il Cadetto Kielani se dovesse essercene la necessità».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Bada al cetriolo, certo», rispose l’Aggiustatutto Meredith.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Richard».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Sì, signora». Poi l’Aggiustatutto Meredith abbassò la voce come se pensasse che la radio non l’avrebbe fatta arrivare alla comandante Tenafly e disse: «Scusa, Cadetto Kielani, non volevo intendere mancanza di rispetto».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Cos’è un cetriolo?»")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Un cetriolo è un ortaggio, di solito servito ghiacciato. C’è un vecchio modo di dire per una persona che resta calma e concentrata in situazioni che mandano nel panico altre persone, che è “fredda come un cetriolo”».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Un colloquialismo», lo identificai. «Nel riferirsi a me come a un cetriolo intendeva comunicare la sua valutazione del fatto che fossi calma e concentrata».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Sì, esatto».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«La sua valutazione è inaccurata. Sono alquanto agitata».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La comandante Tenafly produsse un suono, che mi giunse tramite il microfono dell’Aggiustatutto Meredith, che indicava che era divertita.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Stai dicendo che più sei agitata più diventi formale?»")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Non precisamente. Abitualmente mostro una netta affettazione che non comunica con accuratezza il mio stato mentale».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Suppongo che affettazione abbia un significato diverso da “provare affetto”».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Corretto». Poi, ricordandomi che il dottor Shepherd mi aveva spinta a fornire chiarimenti o contesto, aggiunsi: «Nelle scienze comportamentali è il tono emotivo espresso da una persona. Accigliarsi quando è preoccupata, urlare quando è in collera, arrossire quando è in imbarazzo, sorridere quando è felice, piangere quando è triste...»")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Capito».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Non sempre riconosco quale emozione sto provando, pertanto quando sospetto che tale emozione avrebbe un impatto negativo sulla mia acuità mentale, divento più deliberata nelle mie azioni».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«E parli come un libro stampato?»")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Non sono avvezza a decifrare il linguaggio idiomatico o all’uso appropriato del discorso colloquiale», spiegai. «Parlo quanto più chiaramente e non ambiguamente sono capace di fare».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Perciò quando sei nel panico sembra tu stia chiedendo indicazioni per il campo di baseball?»")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«I campi di baseball sono nei piloni quattro, sedici e ventotto».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Va bene, quindi "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("non ")]), _vm._v("chiederesti indicazioni per i campi di baseball», disse l’Aggiustatutto Meredith. «Buono a sapersi. E, per la cronaca, è perfettamente normale essere agitati mentre si fa qualcosa di così follemente pericoloso che tutto il tuo corpo ti sta urlando di smettere».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Sì», confermai. «Il proposito di questi esercizi è di desensibilizzare il riflesso di sopravvivenza e normalizzare le nostre reazioni a condizioni innaturali».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«A volte aiuta pensare a qualcosa che ami», disse l’Aggiustatutto Meredith. «Qualcosa che ti rende felice».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Questo è stato trattato nell’addestramento. Approssimativamente il venti per cento degli esaminati ha riferito che il rilascio delle endorfine associate ha ridotto lo stress».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Una possibilità su cinque non è grandiosa, ma vale la pena provare», disse l’Aggiustatutto Meredith. «Cosa ti rende felice, Cadetto Kielani?»")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Musica e passione fisica».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Dopo tre misure di silenzio radio, la comandante Tenafly disse: «Lo ha chiesto lei, signor Meredith».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Sì, signora, l’ho fatto», rispose l’Aggiustatutto Meredith. A me disse: «Sto per sganciare la tua corda di sicurezza». Poi ripeté le istruzioni che mi dava ogni volta che avanzavamo. «Resisti all’impulso di sporgerti all’indietro per contrastare l’inerzia in avanti. Il giroscopio della tua tuta è calibrato per mantenerti perpendicolare allo scafo. Cammina in avanti lentamente. Quando sarai entro tre metri dal prossimo anello di sicurezza, la griglia dello scafo rileverà il tuo radiofaro e disporrà un gancio. Non correre né lanciarti verso di esso. Quando lo raggiungi, aggancia la corda di sicurezza all’imbragatura della tua tuta. Capito?»")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Sì», confermai. Poi, decidendo che sarebbe stato appropriato riconoscere i suoi sforzi per rassicurarmi, aggiunsi: «Sto pensando alla musica».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("L’Aggiustatutto Meredith ridacchiò, indicando che trovava divertente la mia assicurazione.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Quando la tensione della corda di sicurezza scomparve, provai la sensazione di star ribaltandomi in avanti. Non lo stavo facendo. Rimasi immobile fino a quando le vertigini non furono passate, poi iniziai a camminare stabilmente in avanti, restando perpendicolare allo scafo.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Sul canale di emergenza della classe sentii Jared Tate rifiutarsi di andare oltre e insistere per restare collegato alla corda di sicurezza. Un’allerta generale sul canale degli Aggiustatutto, che sentii tramite il mio collegamento aperto con l’Aggiustatutto Meredith, avvertì che Walter Ramirez stava deviando dall’esercizio per camminare in una direzione apparentemente casuale e non stava rispondendo alla sua radio. Candy imprecò contro Walter nel canale di emergenza della classe quando lui per poco non si scontrò con lei.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Proseguii verso l’Anello di Sicurezza 6 con l’Aggiustatutto Meredith che presumibilmente manteneva la sua posizione dietro di me. L’Anello 6 era a centoventi metri dalla faccia interna del toroide e a quattrocentocinquanta metri dall’asse rotazionale della stazione, una distanza che non coincideva con un ponte abitato. Stimai che all’Anello 6 l’accelerazione angolare mi avrebbe lanciata verso l’estremità a 0,4G. Il mio utilizzo di "), _c('span', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("lanciata")]), _vm._v(" indicava un’elevata emozione, molto probabilmente ansia, potenzialmente collegata al mio precedente utilizzo di descrittori raccapriccianti. Questo metteva in dubbio la mia stima della velocità angolare. Un bip e una vibrazione indicarono che avevo innescato il rilevatore di prossimità dell’Anello di Sicurezza 6. Dei sostegni, collegati da reticoli e ognuno con in cima una luce gialla lampeggiante e due corde di sicurezza, si sollevarono dallo scafo. Selezionai il sostegno più vicino e collegai la corda di sicurezza al punto fermo della mia tuta.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«D’accordo», disse l’Aggiustatutto Meredith, strascicando le parole. Si agganciò allo stesso sostegno, infrangendo il protocollo nel mettersi dove potevo vederlo. «Ben fatto».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Non ci sono cetrioli sulla Stazione Tombaugh», dissi. «La sua bassa statura, le familiarità con i cetrioli e l’uso di un colloquialismo privo di analogie nello spazio portano alla conclusione che lei sia un terrano. Uno spaziale nato a terra».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Valdosta, Georgia, in effetti. Anche se non mi aspetto che significhi niente per te».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Valdosta, Georgia, è visibile sotto di noi ora?» Terra aveva iniziato la sua traversata.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Lato sbagliato del mondo», disse l’Aggiustatutto Meredith. «Quelli sono il Madagascar che viene pestato, e l’Africa che aspetta il suo turno».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Pestato?»")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Tese la mano per indicare quello che stavamo già guardando. «Vedi quel vortice di nuvole?»")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Sì».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Quello è un ciclone tropicale tardivo... quello che a casa chiamiamo un uragano. È bellissimo da quassù, ma sulla superficie è una forza da temere».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Fece una pausa. Incerta se si aspettasse una risposta o una domanda, rimasi in silenzio.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Il vortice è causato dalla differenza nella pressione atmosferica e nella temperatura», riprese l’Aggiustatutto Meredith, «cosa che sembra abbastanza innocua fino a quando non prendi in considerazione la scala. Quel mulinello che stiamo guardando ha un diametro di circa centocinquanta chilometri, è alto almeno quindici, e i venti che ruotano attorno a quel cerchio vuoto nel mezzo si muovono a più di duecento chilometri all’ora... il tutto con pioggia battente».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("«Clima», identificai. «È per il clima che la lasciato terra?»")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("La risata dell’Aggiustatutto Meredith non aveva la nota derisoria che indicava che avevo commesso un grave errore sociale. Evidentemente la mia domanda l’aveva divertito. «No», rispose. «Il clima è una delle cose che mi mancano di più di quel posto».")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Cercai di immaginare di rimpiangere la perdita di un quarto di milione di chilometri cubi di aria densa come acqua che si spostava a duecento chilometri all’ora. Conclusi che tra l’Aggiustatutto Meredith e me c’era stato un errore di comunicazione.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-260fbc30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c009.vue
// module id = 84
// module chunks = 0